'use client'

import { useEffect } from 'react'

import { useRouter } from 'next/navigation'

import { Button, Typography, Box, Container } from '@mui/material'

import ErrorLayout from './error-layout'

type ErrorProps = {
  error: Error
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  const router = useRouter()

  useEffect(() => {
    if (error) {
      // Include the stack trace for better debugging
      const errorData = {
        message: error.message,
        stack: error.stack,
        name: error.name
      }

      console.log('Sending Error to server for logging:', JSON.stringify(errorData))
      fetch('/api/logerror', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(errorData) // Send the enhanced error data
      })
    }
  }, [error])

  const handleTryAgain = async () => {
    await reset() // Call the reset function first (if needed)
    router.push('/') // Redirect to the home page
  }

  return (
    <ErrorLayout>
      <Container maxWidth='sm'>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh'
          }}
        >
          <Typography variant='h4' component='h1' gutterBottom color='error'>
            Oops! Something went wrong
          </Typography>
          <Typography variant='body1' gutterBottom>
            We&apos;re sorry, but we encountered an unexpected error. Our team has been notified.
          </Typography>
          <Button variant='contained' color='primary' onClick={handleTryAgain}>
            Try again
          </Button>
        </Box>
      </Container>
    </ErrorLayout>
  )
}
